import { render, staticRenderFns } from "./NewsArticleStyleOne.vue?vue&type=template&id=4e0f7b16&scoped=true&"
import script from "./NewsArticleStyleOne.vue?vue&type=script&lang=ts&"
export * from "./NewsArticleStyleOne.vue?vue&type=script&lang=ts&"
import style0 from "./NewsArticleStyleOne.vue?vue&type=style&index=0&id=4e0f7b16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0f7b16",
  null
  
)

export default component.exports